import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { AuthService } from '@service/core/auth.service';
import { ServicosService } from '@service/core/servicos.service';
import { combineLatest } from 'rxjs/operators';

@Injectable()
export class ServicosGuard implements CanActivate {
  constructor(private servicos: ServicosService, private router: Router) {}

  canActivate(): Promise<boolean> {
    return new Promise(resolve => {
      this.servicos
        .buscarUrls()
        .pipe(combineLatest(this.servicos.buscarModulos()))
        .subscribe(
          ([urls, modulos]) => {
            resolve(true);
          },
          err => {
            this.router.navigate(['/login']);
            resolve(false);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/core/servicos-guard.service.ts